(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemDialogController', HandbookMergeItemDialogController);

    HandbookMergeItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookMergeItem', 'HandbookNode', 'HandbookMergeHeader'];

    function HandbookMergeItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookMergeItem, HandbookNode, HandbookMergeHeader) {
        var vm = this;

        vm.handbookMergeItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.handbooknodes = HandbookNode.query();
        vm.handbookmergeheaders = HandbookMergeHeader.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookMergeItem.id !== null) {
                HandbookMergeItem.update(vm.handbookMergeItem, onSaveSuccess, onSaveError);
            } else {
                HandbookMergeItem.save(vm.handbookMergeItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookMergeItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.merged = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
